import AmplitudeUtils from '../../utils/amplitude-utils';
import { getLocalizedString } from '../../utils/i18n-utils';
import BaseForgeCustomizer from '../base-forge';

export interface PasswordRequirementsSelector {
  headerSelector: string;
  itemListSelector: string;
  containerSelector: string;
}

export default abstract class PasswordResetBaseCustomizer extends BaseForgeCustomizer {
  primaryButtonLabel = getLocalizedString('save.and.continue');

  async shouldCustomize() {
    return this.context.formName === 'reenroll-authenticator-warning' || this.context.controller === 'password-expired';
  }

  protected forgifyController() {
    super.forgifyController();
    this.forgifyPasswordRequirements();
  }
  async customize() {
    AmplitudeUtils.logPasswordResetEvent('Landing', {});
    await super.customize();
    this.customizePasswordResetButton();
  }


  protected getPasswordRequirementsSelector(): PasswordRequirementsSelector {
    return {
      containerSelector: '[data-se="password-authenticator--rules"]',
      headerSelector: '.password-authenticator--heading',
      itemListSelector: '.password-authenticator--list',
    };
  }

  protected abstract onPasswordReset(): void

  protected abstract customizePasswordResetButton(): void;

  protected abstract forgifyPasswordRequirements(): void;

}
